import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006bdbb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "show" }


import {TextFieldType} from '@/components/business/crud/interface/FieldType';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import { getArea } from '@/components/business/crud/widgets/impl/area';


export default /*#__PURE__*/_defineComponent({
  __name: 'AreaTable',
  props: {
    propName: {},
    widget: {},
    info: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(getArea)(_ctx.data[_ctx.propName])?.path), 1))
}
}

})